import React from 'react';
import { Avatar, Stack, Typography } from '@mui/material';
import noDataImg from '../Assets/Image/noDataFound.svg'

export default function DataNotFound({ imgSrc, imgAlt = 'No Data', text = 'Sorry! No Data found.', size = 200 }) {
  return (
    <Stack alignItems="center" justifyContent="center" spacing={2} sx={{ width: '100%', height: '100%' , py: 4 }}>
      <Avatar
        src={noDataImg}
        alt={imgAlt}
        sx={{
          width: size,
          height: size,
          bgcolor: 'transparent',
          borderBottom: '1px solid #f0f0f0',
        }}
        variant="square"
      />

      <Typography
        sx={{
          fontFamily: 'Poppins',
          fontWeight: 400,
          fontSize: 14,
          color: '#000000',
          textAlign: 'center',
        }}
      >
        {text}
      </Typography>
    </Stack>
  );
}